import { INavigationInfo, INavigationItemInfo, NAV_NAME, NavigationPageType } from "@umu/umu-api";

// 更新类型
enum UPDATE_ACT_TYPE {
    INIT,
    UPDATE_NAVIGATION_CONFIG,
    UPDATE_NAVIGATION_LIST,
}
interface IIconItemInfo {
    iconName: string;
    activeIconName?: string;
    desc?: string;
    remark?: string;
    url?: string;
    activeUrl?: string;
}

interface IAppNavigationItemIcon {
    svg?: {
        normal_url: string;
        normal_color: string;
        icon_name: string;
        selected_url: string;
        selected_color: string;
    };
    custom?: {
        normal_url: string;
        selected_url: string;
    };
}
/**
 * @desc 功能导航配置信息设置页面属性
*/
interface INavigationPageAddProps extends React.HTMLAttributes<HTMLDivElement> {
    prefixCls?: string;// 样式前缀
    isShowIconList?: boolean;// 是否显示图标列表 - 修改图标弹窗中
    isShowColor?: boolean;// 是否显示颜色选择器 - 修改图标弹窗中
    prefixElement?: React.ReactNode;// 前置元素
    suffixElement?: React.ReactNode;// 后置元素
    isHideFooter?: boolean;// 是否隐藏底部
    params?: Record<string, string>;// 请求参数
    okProps?: any;// 确定按钮属性
    okText?: string;// 确定按钮文案
    cancelText?: string;// 取消按钮文案
    defaultList?: INavigationItemInfo[];// 默认图标列表
    pageType?: NavigationPageType;// 页面类型
    isCloseInitLoading?: boolean;// 是否关闭初始化加载数据
    onLoadNavigation?: (pageType?: NavigationPageType, params?: Record<string, string>) => Promise<INavigationInfo>;// 加载导航回调
    onClose?(): void;// 关闭弹窗回调
    onUpdate?: (data: INavigationItemInfo[]) => void;// 更新页面信息回调函数
    onSave?: (data: INavigationItemInfo[], params?: Record<string, string>) => Promise<{isSuccess: boolean}>;// 保存按钮回调函数
    onSuccess?: (data?: { isSuccess: boolean, params?: Record<string, string>, list: INavigationItemInfo[]}) => void;// 配置成功回调函数
}
enum OPERATE_ACT_TYPE {
    UP_MOVE,
    RE_MOVE,
    PREVIEW,
    ICON_CHANGE,
    UPDATE_TITLE,
    UPDATE_STATUS,
}
interface IOperateData {
    key?: string;
    rowData: INavigationItemInfo;
    index: number;
    step?: number;
}
interface IColumnsProps {
    isValid: boolean;
    isShowIconList?: boolean;
    isShowColor?: boolean;
    pageType: NavigationPageType;
    onOperateCallback: (type: OPERATE_ACT_TYPE, data: IOperateData) => void;
}
export {
    NAV_NAME,
    IColumnsProps,
    OPERATE_ACT_TYPE,
    IOperateData,
    IIconItemInfo,
    IAppNavigationItemIcon,
    UPDATE_ACT_TYPE,
    INavigationPageAddProps
}
